import { useCallback, useMemo } from 'react';
import { ArtistPortalPlaylistRow } from 'fym-shared/src/smartlinks/artistPortals';
import { useGetArtistPortalPlaylistsQuery } from '../../../../redux/api/fymAPI';

/**
 * The playlists of the newest snapshot of each source: the portal playlists and the Ditto
 * playlists (design d3), the most streams first, then the most followers.
 */
export function usePortalPlaylists(accountId: number) {
  const { data, isLoading, error, refetch } = useGetArtistPortalPlaylistsQuery({ accountId });
  const playlists = useMemo(
    () =>
      [...(data?.playlists ?? [])].sort((left: ArtistPortalPlaylistRow, right: ArtistPortalPlaylistRow) => {
        const byStreams = (right.streams28d ?? -1) - (left.streams28d ?? -1);
        return byStreams !== 0 ? byStreams : (right.followers ?? -1) - (left.followers ?? -1);
      }),
    [data]
  );
  const retry = useCallback(() => {
    refetch().catch(console.error);
  }, [refetch]);
  return { playlists, isLoading, error, retry };
}
